<template>
  <div>
  <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        
        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo bold">Usuarios</span>
                </div>
                <div class="col-6 col-md-6">
                  <router-link class="btngris float-right"
                  to="/nuevo-usuario" v-if="this.$store.state.user.user_level == 1">
                    Nuevo usuario
                  </router-link>
                </div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12" v-if="this.data != null">
                    <v-client-table :columns="columns" v-model="data" :options="options">
                      
                      
                      <a slot="user_level" slot-scope="props">
                          <span v-if="props.row.user_level == 1">Administrador</span>
                          <span v-if="props.row.user_level == 10">Básico</span>
                      </a>

                      <router-link
                        slot="uri"
                        slot-scope="props"
                        :to="'/usuario/'+props.row.id"
                        class="text-center negro"
                      >
                        <i class="fas fa-eye"></i> Ver
                      </router-link>

                      <!-- <router-link
                        slot="baja"
                        slot-scope="props"
                        :to="'/dashboard/alumnos/baja/'+props.row.id"
                        class="text-center"
                      >
                        <i class="fas fa-times"></i>
                      </router-link>

                      <router-link
                        slot="bloqueo"
                        slot-scope="props"
                        :to="'/dashboard/alumnos/bloqueo/'+props.row.matricula"
                        class="text-center"
                      >
                        <i class="fas fa-lock-open"></i>
                      </router-link> -->

                      <!-- <div slot="grupos" slot-scope="props">
                        <div v-for="item in props.row.grupos" v-bind:key="item">
                          <router-link
                            :to="'/dashboard/alumnos/grupos/'+item.id_grupo+'/'+props.row.matricula"
                          >
                            {{item.nombre}}
                          </router-link>
                        </div>
                      </div> -->

                      <!-- <div slot="child_row" slot-scope="props">
                      <a
                        class="pr-5"
                        target="_blank"
                        :href="baseurl+'uploads/'+props.row.img_qr"
                      >
                        <img
                          :src="baseurl+'uploads/'+props.row.img_qr"
                          alt="qr"
                          width="100"
                        />
                      </a>

                      <a
                        target="_blank"
                        :href="baseurl+'uploads/'+props.row.img_ticket"
                      >
                        <img
                          :src="baseurl+'uploads/'+props.row.img_ticket"
                          alt="qr"
                          width="100"
                        />
                      </a>
                      </div>-->

                      <div
                        slot="name"
                        slot-scope="{row, update, setEditing, isEditing, revertValue}"
                      >
                        <span @click="setEditing(true)" v-if="!isEditing()">
                          <a>{{row.name}}</a>
                        </span>
                        <span v-else>
                          <input type="text" v-model="row.name" />
                          <button
                            type="button"
                            class="btn btn-info btn-xs"
                            @click="update(row.name); setEditing(false)"
                          >Submit</button>
                          <button
                            type="button"
                            class="btn btn-default btn-xs"
                            @click="revertValue(); setEditing(false)"
                          >Cancel</button>
                        </span>
                      </div>
                    </v-client-table>
                  </div>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from 'moment';

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String
  },
  data() {
    return {
      tiposervicio: "",
      columns: [
        "uri",
        "user_level",
        "contratante",
        "user_email",
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        
        
        //"uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 25,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {

          user_email: "Email",
          nombre: "Nombre",
          email: "Email",
          user_level:"Nivel",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo"
        },
        editableColumns: ["name"],
        sortable: ["user_level",
        "contratante",
        "user_email",
        "nombre",
        "apellido_paterno",
        "apellido_materno"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} usuarios|{count} usuarios|Un usuario",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar usuario",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
  this.$store.state.user = JSON.parse(this.$cookie.get('usergaig'));
    AOS.init();

    this.consulta();

    // this.data = [
    //   {
    //     id: 34,
    //     fecha: '01/07/2021',
    //     contratante: "Fulano Pérez",
    //     email: "fperez@gmail.com",
    //     no_poliza: "CPM210000000100",
    //     no_certificado: "CPM21000000010000001",
    //     detalle: true
    //   },
    //    {
    //     id: 35,
    //     fecha: '01/07/2021',
    //     contratante: "Mengano Pérez",
    //     email: "mperez@gmail.com",
    //     no_poliza: "CPM210000000200",
    //     no_certificado: "CPM21000000010000002",
    //     detalle: true
    //   },

    // ];

  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
       admin_id: this.$store.state.user.admin_id
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-usuarios.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos;
              
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        /*nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        tel: this.tel,
        no_ticket: this.no_ticket,
        sede: this.sede*/
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(userData));

      this.$http
        .post(vm.$store.state.baseurl + "alumnos/consulta-alumno.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              this.registro = 1;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      this.$router.push("dashboard");
    }
  }
};
</script>

